import React from 'react';
import LoadingIndicatorCommon from './LoadingIndicatorCommon';

const LoadingIndicator = ({ loading }) => {
    return (
        <LoadingIndicatorCommon
            loading={loading}
        />
    );
}

export default LoadingIndicator;